"use client";
//#region packages/@mantine/core/src/components/VisuallyHidden/VisuallyHidden.module.css
var VisuallyHidden_module_default = { "root": "m_515a97f8" };
//#endregion
export { VisuallyHidden_module_default as default };

//# sourceMappingURL=VisuallyHidden.module.mjs.map